import getRandomNumbersArrayBetween from "./getRandomNumbersArrayBetween";
import getDateArrayBetweenDates from "./getDateArrayBetweenDates";

/**
 * @param {string} startDate - Fecha de inicio formato YYYY-MM-DD
 * @param {string} endDate - Fecha de fin formato YYYY-MM-DD
 * @returns {Array<{name: String, type: String, data: Array<Number>}>} - Retorna series para el gráfico diario de
 */
export default function getFakeSeriesGraficoDiario(startDate, endDate) {
    const daysOf2022 = getDateArrayBetweenDates(startDate, endDate);
    const data1 = getRandomNumbersArrayBetween(0, 1000, daysOf2022.length);
    const data2 = getRandomNumbersArrayBetween(0, 1000, daysOf2022.length);
    const data3 = getRandomNumbersArrayBetween(0, 1000, daysOf2022.length);
    const data4 = getRandomNumbersArrayBetween(0, 1000, daysOf2022.length);

    return [
        {
            name: "TX WCHAT",
            type: "column",
            data: data1,
        },
        {
            name: "TX WSP",
            type: "column",
            data: data2,
        },
        {
            name: "AG WCHAT",
            type: "line",
            data: data3,
        },
        {
            name: "AG WSP",
            type: "line",
            data: data4,
        },
    ];
}